/**
 * @file 新闻列表页tab
 * @author FengGuang(fengguang01@baidu.com)
 */
import React from 'react';
import classNames from 'classnames';
import {ITagItem} from '../../type';

interface IProps {
    currentTag: ITagItem;
    tagList: ITagItem[];
}

const TagList: React.FC<IProps> = props => {
    const tagList = props.tagList;
    const currentTag = props.currentTag;

    return (
        <div className="paddle-category-list paddle-news-tags">
            {tagList.map(tag => (
                <a
                    key={tag.id}
                    href={tag.link}
                    className={classNames(
                        `paddle-news-tags-item`,
                        {'paddle-news-tags-active': tag.id === currentTag.id})
                    }
                >
                    {tag.name}
                </a>
            ))}
        </div>
    );
};

export default TagList;
